import { cn } from '../../lib/cn';
import type { QualityObservabilityRow } from '../../masterplatform/framework';

type Props = { items?: QualityObservabilityRow[] };

export function QualityObservabilityPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.category}-${item.item}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs text-slate-500">{item.category}</p>
              <p className="text-sm font-medium">{item.item}</p>
            </div>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              item.status === 'passing' || item.status === 'passed' || item.status === 'approved' || item.status === 'active'
                ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
                : 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300',
            )}>
              {item.status}
            </span>
          </div>
          <div className="mt-2 h-2 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div
              className={cn('h-full rounded-full', item.score >= 98 ? 'bg-success-500' : 'bg-brand-500')}
              style={{ width: `${item.score}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
